import { render, staticRenderFns } from "./CouponAndOffer.vue?vue&type=template&id=5f642cb7&scoped=true"
import script from "./CouponAndOffer.vue?vue&type=script&lang=js"
export * from "./CouponAndOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f642cb7",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage});
